import { ILLUSTRATION } from "@constants/images";
import { useEffect, useState } from "react";
import IllustrationMintCase from "./IllustrationMintCase.component";
import NftsQueue from "./NftsQueue";
import { SCOREMethodGetCall } from "@services/icon";
import { ENUM_SCORES } from "@enum/contracts.enum";
import { SALES_STATE } from "@enum/salesStatus.enum";

const IllustrationHome = () => {
  const [reservation, setReservation] = useState([]);
  const [reservationState, setReservationState] = useState(false);
  const [days, setDays] = useState<number>(0);
  const [hours, setHours] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);

  const timeDifference = (date1: any, date2: any) => {
    let difference = date1.getTime() - date2.getTime();
    if(date1>date2){
      let daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
      difference -= daysDifference * 1000 * 60 * 60 * 24;
  
      let hoursDifference = Math.floor(difference / 1000 / 60 / 60);
      difference -= hoursDifference * 1000 * 60 * 60;
  
      let minutesDifference = Math.floor(difference / 1000 / 60);
      difference -= minutesDifference * 1000 * 60;
  
      let secondsDifference = Math.floor(difference / 1000);
      setDays(daysDifference);
      setHours(hoursDifference);
      setMinutes(minutesDifference);
      setSeconds(secondsDifference);
    }else{
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);

    }
    }


  const updateTime = (timeStampBlockchain: any) => {
    setInterval(async () => {
      const timestamp = new Date(timeStampBlockchain / 1000);
      timeDifference(timestamp, new Date());
    }, 1000);
  };

  useEffect(() => {
    SCOREMethodGetCall("getSaleOverTime", ENUM_SCORES.ILLUSTRATION_MINT).then(
      (timeStampBlockchain: any) => {
        SCOREMethodGetCall("getSaleStatus", ENUM_SCORES.ILLUSTRATION_MINT).then(
          (salesStatus) => {
            if (salesStatus.value === SALES_STATE.SALE_STARTED) {
              const timestamp = new Date(
                Number(timeStampBlockchain) / 1000
              ).getTime(); // millisecond
              const current_timestamp = new Date().getTime(); //millisecond

              console.log("timestamp", timestamp);
              console.log("current_timestamp", current_timestamp);

              if (current_timestamp > timestamp) {
                //sale complete
                console.log("Sale has completed!");
              } else {
                //sale still in progress
                updateTime(timeStampBlockchain);
              }
            }
          }
        );
      }
    );
  }, []);

  useEffect(() => {
    const getReservation = async () => {
      const reservation = await SCOREMethodGetCall(
        "getReservations",
        ENUM_SCORES.ILLUSTRATION_MINT
      );
      setReservation(reservation);
    };
    getReservation();
  }, [reservationState]);
  return (
    <>
      <div className="mint-wrapper">
        <div className="mint-banner-text ">
          <div className="mint-banner-info">
            <h3 className="mint-info-heading">
              GangstaBet <br />
              Illustrative Art - <br /> Black Friday Sale !
            </h3>

            {!(days == 0 && hours == 0 && minutes == 0 && seconds == 0) && (
              <span style={{ fontSize: "20px" }} className="mint-info-desc">
                Reservations open for: <br />
                <span style={{ color: "red" }}>
                  {days}D :{hours}H :{minutes}M :{seconds}S
                </span>
              </span>
            )}
            <p className="mint-info-desc">
            Get a personalized illustrative art of your GangstaBet NFT and have it featured in the loading screen of our new GangstaVerse website as well as on the billboards inside Emerald City.
            </p>
            <p className="mint-info-note">
              Note: The arts will be created after placing an order for specific
              NFTs. Please expect a certain waiting time to receive the NFTs.
              Two arts will be delivered each week and it will be on a “First
              come, First serve” basis.
            </p>
            <IllustrationMintCase setReservationState={setReservationState} />
          </div>
          <div className="mint-banner-illustration">
            <img src={ILLUSTRATION.NFT_PJ} alt="illustration-nft" />
          </div>
        </div>
        {reservation.length > 0 && (
          <NftsQueue
            reservationState={reservationState}
            reservation={reservation}
          />
        )}
      </div>
    </>
  );
};

export default IllustrationHome;
